import React,{useState,useEffect} from 'react'
import { SmsPageStyle } from './SmsPage.styled'
import TopBar from '../../components/TopBar/TopBar'
import Footer from '../../components/footer/Footer'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { checkSms } from '../../api/SmsApi'

const redirectToPlayStore = () => {
    window.location.href = window.playStore;
  };

  const redirectToAppStore = () => {
    window.location.href = window.appStore;
  };

const VerifiedComponent=({validate})=>{
  const smsArr=["accept","reject","block"]
  return <>
    {validate === "accept" && 
            <div className='body'>
              <p className='description' >TagMe™ Notifications</p>
              <img src={`${process.env.PUBLIC_URL}/acceptIcon.png`} alt="Logo"  />
              <p className='smsTxt'>Accepted!</p>
              <p className='smsTxt'>You've agreed to recieve these notifications. You can change this in future in the Ocufii Notify app.</p>
              <button className='btn form-button' onClick={redirectToAppStore}>Download from App store</button>
              <button className='btn form-button' onClick={redirectToPlayStore}>Download from Play store</button>
            </div>
          }
    {validate === "reject" && <div className='body'>
            <p className='description' >TagMe™ Notifications</p>
              <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo"  />
              <p className='smsTxt'>Declined</p>
              <p className='smsTxt'>You've declined recieving notifications from this asset.</p>
              <p className='smsTxt'>You can change this in the future in the Ocufii Notify App</p>
              <button className='btn form-button' onClick={redirectToAppStore}>Download from App store</button>
              <button className='btn form-button' onClick={redirectToPlayStore}>Download from Play store</button>
            </div>
          }

          {validate === "block" && <div className='body'>
              <p className='description' >TagMe™ Notifications</p>
              <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo"  />
              <p className='smsTxt'>Blocked</p>
              <p className='smsTxt'>You've blocked this user from adding you to notifications in the future. You can change this at any time in the ocufii Notify App.</p>
              <p className='smsTxt2'>Experiencing harassment? Contact Ocufii support.</p>
              <button className='btn form-button' onClick={redirectToAppStore}>Download from App store</button>
              <button className='btn form-button' onClick={redirectToPlayStore}>Download from Play store</button>
            </div>
          }

          {smsArr.includes(validate) 
            ? <></>
            :
            <div className='body'>
              <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo"  />
              <p className='smsTxt'>Link Expired</p>
            </div>
          }

  </>
}

const SmsPage = () => {
    const {action,email,otp}=useParams()
    
    
    const [validate, setValidate] = useState("error")
    const [enableAPI, setEnableAPI] = useState(false)
    

    

    const {
    status : smsStatus,
    data: smsData,
    }=useQuery({
      queryKey:["SmsPage",otp],
      queryFn:()=>checkSms(action,email,otp),
      enabled:enableAPI,
      onSuccess:(data)=>{
        if(data.status===400){
          
          setValidate("error")
        }else{
          setValidate(action)
        }
        setEnableAPI(false)
      },
      onError:()=>{
        setValidate("error")
        setEnableAPI(false)
      }

    })


    useEffect(() => {
      if(email || otp){
        setEnableAPI(true)
      }else{
        setEnableAPI(false)
      }
    }, [email,otp])

  
    
    
  return (
    <SmsPageStyle>
        <TopBar  />
         {smsStatus==="loading"?
          <div className='body'>
            <p className='description'>Loading ...</p>
          </div>
          :
          <VerifiedComponent  validate={validate}/>
        }
       
        
          
        
        
        <Footer />
    </SmsPageStyle>
  )
}

export default SmsPage